import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
	selector: 'app-old-app-info-dialog',
	templateUrl: './old-app-info-dialog.component.html',
	styleUrl: './old-app-info-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OldAppInfoDialogComponent {
	constructor(public dialogRef: MatDialogRef<OldAppInfoDialogComponent>) {}

	ngOnInit() {}
	close() {
		this.dialogRef.close();
	}
}
